import React from "react";
import { AppTitle, MainBarWrapper } from "./Styled";
import logoImg from "../../../shared/svg/AppLogo/logo.png";

const MainBar = () => {
    return (
        <MainBarWrapper>
            {/* <AppLogo /> */}
            <div style={{ display: "flex", alignItems: "center" }}>
                <img src={logoImg} alt="" width={"32px"} />
            </div>
            <AppTitle>PMSO</AppTitle>
        </MainBarWrapper>
    );
};

export default MainBar;
